// extracted by mini-css-extract-plugin
export default {"orangeRound":"Rounds_orangeRound__kDyCs","whiteRound":"Rounds_whiteRound__jM-pB","greyRound":"Rounds_greyRound__pWx4H"};